/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 */
"use strict";

const isCombiningCharacter = require("./is-combining-character");
const isEmojiModifier = require("./is-emoji-modifier");
const isRegionalIndicatorSymbol = require("./is-regional-indicator-symbol");
const isSurrogatePair = require("./is-surrogate-pair");

module.exports = {
    isCombiningCharacter,
    isEmojiModifier,
    isRegionalIndicatorSymbol,
    isSurrogatePair
};
